import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DegreeTypes from '@static/data/degree_type_autocomplete.json';

import AutocompleteField from '../AutocompleteField';

export class DegreeField extends Component {
  static propTypes = {
    /**
     * Connects your input component to Redux whose props are destructured into
     * your `<input/>` component.
    */
    input: PropTypes.shape({
      placeholder: PropTypes.string,
    }).isRequired,

    onChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
    value: PropTypes.string.isRequired,
  }

  static defaultProps = {
    onSelect: () => {},
  }

  handleSelect = (value, item) => {
    const { onChange, onSelect } = this.props;
    onChange(value);

    // pass item to onSelect to be able to set degree_name and type fields
    onSelect(value, item);
  }

  shouldItemRender = (item, value) => (
    item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
  )

  render() {
    const { input, onChange, value } = this.props;

    // sort degree types alphabetically
    const sortedDegreeTypes = DegreeTypes.sort((a, b) => a.label.localeCompare(b.label));

    return (
      <div className="DegreeField">
        <AutocompleteField
          getItemValue={(item) => item.name}
          items={sortedDegreeTypes}
          renderItem={(item, isHighlighted) => (
            <div className={`item ${isHighlighted ? 'item_highlighted' : ''}`} key={item.label}>
              {item.label}
            </div>
          )}
          autoHighlight
          onChange={onChange}
          onSelect={this.handleSelect}
          renderMenu={(items) => <div className="menu">{items}</div>}
          selectOnBlur
          shouldItemRender={this.shouldItemRender}
          inputProps={{ ...input, id: 'LabeledField_name' }}
          value={value}
          wrapperStyle={{}}
        />
      </div>
    );
  }
}

export default DegreeField;
